import { render, staticRenderFns } from "./Xmjz.vue?vue&type=template&id=847ec0f4&scoped=true&"
import script from "./Xmjz.vue?vue&type=script&lang=js&"
export * from "./Xmjz.vue?vue&type=script&lang=js&"
import style0 from "./Xmjz.vue?vue&type=style&index=0&id=847ec0f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "847ec0f4",
  null
  
)

export default component.exports